import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/aadityasahay/Documents/code/fabric-carousel/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { CarouselProvider, Slide, Slider } from 'fabric-carousel';
import { Playground } from 'docz';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "styling"
    }}>{`Styling`}</h1>
    <p>{`The styles of slide and buttons can be customised by passing a the styles as string through a styling prop.`}</p>
    <h2 {...{
      "id": "slide"
    }}>{`Slide`}</h2>

    <Playground __position={0} __code={'<CarouselProvider\n  value={{\n    width: \'100%\',\n    height: \'100%\',\n    visibleCount: 1,\n    visibleIndex: 1,\n    totalSlides: 1,\n    infinite: true,\n    slideshow: false,\n    slideshowDuration: 1000,\n    transitionDuration: \'0.4s\',\n  }}\n>\n  <Slider>\n    <Slide\n      index={1}\n      styling={`\n              border: 3px solid red;\n          `}\n    >\n      <h1>hi</h1>\n    </Slide>\n  </Slider>\n</CarouselProvider>'} __scope={{
      props,
      DefaultLayout,
      CarouselProvider,
      Slide,
      Slider,
      Playground
    }} mdxType="Playground">
    <CarouselProvider value={{
        width: "100%",
        height: "100%",
        visibleCount: 1,
        visibleIndex: 1,
        totalSlides: 1,
        infinite: true,
        slideshow: false,
        slideshowDuration: 1000,
        transitionDuration: "0.4s"
      }} mdxType="CarouselProvider"> 
        <Slider mdxType="Slider">
            <Slide index={1} styling={`
                border: 3px solid red;
            `} mdxType="Slide">
                <h1>
                    hi
                </h1>
            </Slide>
        </Slider>
    </CarouselProvider>
    </Playground>
    <h2 {...{
      "id": "buttons"
    }}>{`Buttons`}</h2>
    <Playground __position={1} __code={'<CarouselProvider\n  value={{\n    width: \'100%\',\n    height: \'100%\',\n    visibleCount: 1,\n    visibleIndex: 1,\n    totalSlides: 1,\n    infinite: true,\n    slideshow: false,\n    slideshowDuration: 1000,\n    transitionDuration: \'0.4s\',\n  }}\n>\n  <Slider\n    buttonStyling={`\n          border: none;\n          background: transparent;\n          box-shadow: 0 0 3px #121212;\n          border-radius: 50%;\n          transition: all 0.2s;\n          outline:none;\n          font-size: 22px;\n          color: #121212;\n          &:hover {\n              box-shadow: 0 0 10px;\n              transform: scale(1.1);\n          }\n      `}\n    leftButtonText={<strong>{\'<\'}</strong>}\n    rightButtonText={<strong>{\'>\'}</strong>}\n  >\n    <Slide index={1}>\n      <h1>hi</h1>\n    </Slide>\n  </Slider>\n</CarouselProvider>'} __scope={{
      props,
      DefaultLayout,
      CarouselProvider,
      Slide,
      Slider,
      Playground
    }} mdxType="Playground">
    <CarouselProvider value={{
        width: "100%",
        height: "100%",
        visibleCount: 1,
        visibleIndex: 1,
        totalSlides: 1,
        infinite: true,
        slideshow: false,
        slideshowDuration: 1000,
        transitionDuration: "0.4s"
      }} mdxType="CarouselProvider"> 
        <Slider buttonStyling={`
            border: none;
            background: transparent;
            box-shadow: 0 0 3px #121212;
            border-radius: 50%;
            transition: all 0.2s;
            outline:none;
            font-size: 22px;
            color: #121212;
            &:hover {
                box-shadow: 0 0 10px;
                transform: scale(1.1);
            }
        `} leftButtonText={<strong>{"<"}</strong>} rightButtonText={<strong>{">"}</strong>} mdxType="Slider">
            <Slide index={1} mdxType="Slide">
                <h1>
                    hi
                </h1>
            </Slide>
        </Slider>
    </CarouselProvider>
    </Playground>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      